import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[cignaTabLabel]',
})
export class TabLabelDirective {
  constructor(public template: TemplateRef<any>) {}
}
